// extracted by mini-css-extract-plugin
export default {"form":"Home_form__lwU6M"};